import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import httpClient from '../../../utils/http-client';
import { handleError } from '../../../utils/utils';
import { editParentFailure, editParentSuccess, fetchParentsStart } from '../actions';
import staffActionTypes from '../types';

export function* editParent({ payload }) {
  const { data, callback } = payload;
  const editPayload = data;
  try {
    const response = yield httpClient.put('/parents', editPayload);
    yield put(editParentSuccess(response.data));
    const data = {
      offset: 0,
      limit: 10,
    };
    yield put(fetchParentsStart(data));
    Notify('Parent Edited successfully', { position: 'top-right' });
    callback?.();
  } catch (error) {
    yield put(editParentFailure(error?.message));
    const err = handleError(error);
  }
}

export function* onEditParentStart() {
  yield takeLatest(staffActionTypes.EDIT_PARENT_START, editParent);
}
